import React from 'react'

const SvgPrinterOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path d='M19 9.007h1a2 2 0 012 2v6c0 1.333-.667 2-2 2h-1v1c0 1.333-.667 2-2 2H7c-1.333 0-2-.666-2-2v-1H4c-1.333 0-2-.667-2-2v-6a2 2 0 012-2h1v-4c0-1.654 1.218-3 2.714-3h6.282c.367-.027.686.026.956.161.27.135.62.415 1.048.84l2.125 2c.41.393.66.726.745 1 .087.274.13.608.13 1.003v1.996zm-12 11h10v-3H7v3zm0-15v4h10V6.693l-2.828-2.686H7.714c-.387 0-.714.458-.714 1zM4 11v6h1v-2h14v2h1v-6H4zm14 3.007a1 1 0 110-2 1 1 0 010 2z' />
  </svg>
)

export default SvgPrinterOutline
